import { create } from 'zustand'
import type { MeResponse } from '@/types/api'

interface AuthState {
  user: MeResponse | null
  setUser: (u: MeResponse | null) => void
  teamId: string | null
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  teamId: null,
  setUser: (user) => set({ user, teamId: user?.team_id ?? null }),
}))
